import React from 'react'
import { Field, ErrorMessage } from 'formik'
import TextError from './TextError'
import './style/RadioButton.css'

function RadioButtons(props) {
  const {
    label,
    name,
    options,
    innerHTML = false,
    fileId,
    url,
    ...rest
  } = props
  return (
    <div className="RadioButtons">
      {innerHTML ? (
        <label
          dangerouslySetInnerHTML={{
            __html: label,
          }}
        ></label>
      ) : (
        <label>{label}</label>
      )}
      {fileId && (
        <div className="RadioButtons__img">
          <img src={url} alt="" />
        </div>
      )}
      <Field name={name}>
        {({ field }) => {
          return options.map((option) => {
            return (
              <div className="RadioButtons__input" key={option.key}>
                <input
                  type="radio"
                  id={option.value}
                  {...field}
                  {...rest}
                  value={option.value}
                  checked={field.value === option.value}
                />
                <label htmlFor={option.value}>
                  {option.FileId ? (
                    <center>
                      <img src={option.key} alt="" />
                    </center>
                  ) : (
                    option.key
                  )}
                </label>
              </div>
            )
          })
        }}
      </Field>
      <ErrorMessage component={TextError} name={name} />
    </div>
  )
}

export default RadioButtons
